import React, { MouseEvent } from 'react';
import classnames from 'classnames';

import { fc } from 'i18n';
import { ISelectOption } from 'types/select';

import styles from './styles.module.css';

interface IListProps<T> {
  isSelected: boolean;
  option: ISelectOption<T>;
  selectOption: (option: ISelectOption<T>) => (event: MouseEvent<HTMLDivElement>) => void;
}

export const Option = <T,>({ isSelected, option, selectOption }: IListProps<T>) => {
  const className = classnames(styles.option, { [styles.selected]: isSelected });

  return (
    <div className={className} onClick={selectOption(option)}>
      {fc(option.label)}
    </div>
  );
};
